module.exports = __webpack_public_path__ + "img/tablet-screen-active.37eb074b.svg";